export default "/assets/images/mila-filter-video-1.mp4?b8a1b4f10d09c96085ec43c51370a455";